import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import AppBar from "@mui/material/AppBar";
import HeaderUserInfo from "../HeaderUserInfo";
import HeaderNavigation from "../HeaderNavigation";
import {
  HeaderContainerBg,
  HeaderToolBar,
  LogoAndText,
  ConnectionsTextBox,
  ConnectionsText,
  HeaderUserDashboard,
  HeaderLegacyText,
  HeaderLegacyClickHere,
  ConnectionsIconBox,
  LogoTextAndNavigation,
  LogoBox,
  HeaderLogo,
} from "./Header.styles";
import { useTranslation } from "react-i18next";
import { getSessionFromStorage } from "../../utils/session";
import { profileDetailsAction } from "../../store/actions/auth-actions";
import { ReactComponent as ConnectionsIcon } from "../../assests/icons/connections_header_icon.svg";
import { ReactComponent as LegacySwitchIcon } from "../../assests/icons/switch_to_legacy.svg";
import { homeToken } from "../../utils/constant";
import {
  LogoSkelton,
  NavigationSkelton,
  UserInfoSkeleton,
  LegacyTextSkeleton,
} from "./Header.Skeleton";
import { redirectToConnectHome } from "../../utils/config";
import MobileNavigationMenu from "../MobileNavigationMenu";
import { Tooltip } from "@mui/material";

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profileDetails = useSelector((state) => state.profileDetails);
  const { status: authStatus } = useSelector((state) => state.auth.data);
  const isHeaderShrink = useSelector(state=>state.header.isHeaderShrink);

  useEffect(() => {
    const tokenValue = getSessionFromStorage();
    if (tokenValue || authStatus === "success") {
      dispatch(profileDetailsAction(tokenValue.access_token));
    }
  }, [dispatch, authStatus]);

  const handleGoToLegacy = () => {
    window.location.href = `/web/secure/networkManageConnections`;
  };

  return (
    <AppBar position="sticky">
      <HeaderContainerBg isHeaderShrink={isHeaderShrink}>
        <HeaderToolBar disableGutters>
          <LogoTextAndNavigation isHeaderShrink={isHeaderShrink}>
            <LogoAndText>
              <LogoBox>
                {Object.keys(profileDetails.data).length >= 1 ? (
                  <HeaderLogo onClick={redirectToConnectHome} isHeaderShrink={isHeaderShrink} />
                ) : (
                  <LogoSkelton />
                )}
              </LogoBox>
              <ConnectionsTextBox>
                <ConnectionsText variant="h1" isHeaderShrink={isHeaderShrink}>
                  {t(homeToken.Connections)}
                </ConnectionsText>
              </ConnectionsTextBox>
            </LogoAndText>
            {Object.keys(profileDetails.data).length >= 1 ? (
              <HeaderNavigation />
            ) : (
              <NavigationSkelton />
            )}
          </LogoTextAndNavigation>
          {/* Mobile Appbar */}
          <MobileNavigationMenu />
          {/* Mobile Appbar ends */}
          <ConnectionsIconBox>
          {!isHeaderShrink && <ConnectionsIcon />}
          </ConnectionsIconBox>
          <HeaderUserDashboard isHeaderShrink={isHeaderShrink}>
            {Object.keys(profileDetails.data).length >= 1 ? (
              <HeaderUserInfo />
            ) : (
              <UserInfoSkeleton />
            )}
            {Object.keys(profileDetails.data).length >= 1 ? (
              <HeaderLegacyText>
              <Tooltip
                title={`${t(homeToken.ClickHere)} ${t(homeToken.LegacyText)}`}
                placement="bottom"
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#ffffff",
                      color: "#676767",
                      boxShadow: "1px 1px 1px 1px #c8c8c8",
                      textTransform:"capitalize",
                      "& .MuiTooltip-arrow": {
                        color: "#cf2030",
                      },
                    },
                  },
                }}
               >
               <LegacySwitchIcon onClick={handleGoToLegacy}/>
               </Tooltip>
            </HeaderLegacyText>
            ) : (
              <LegacyTextSkeleton />
            )}
          </HeaderUserDashboard>
        </HeaderToolBar>
      </HeaderContainerBg>
    </AppBar>
  );
};

export default Header;
